var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"screen-flow-content"},[_c('v-stepper-content',{attrs:{"step":_vm.index}},[(_vm.isActive)?[_vm._t("default")]:_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }